import { render } from "./DivisionalChartImage.vue?vue&type=template&id=3bf7cfcc&scoped=true"
import script from "./DivisionalChartImage.vue?vue&type=script&lang=js"
export * from "./DivisionalChartImage.vue?vue&type=script&lang=js"

import "./DivisionalChartImage.vue?vue&type=style&index=0&id=3bf7cfcc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf7cfcc"]])

export default __exports__